import { formatPrice } from "../../../utils/common";
import defaultImage from '../../../images/default-bc-product.png'

export const parseProductReportRow = (row: any) => ({
  id: row.id,
  sku: row.parent_sku || '-',
  childSku: row.sku || '-',
  productName: row.product_title || '-',
  cost: formatPrice(row.cost || 0, false),
  purchaserName: row.purchaser_name || '-',
  thumbnail_url: row.thumbnail_url || defaultImage,
  variants: row.child_data
    ? row.child_data.map((variant: any) => ({
        ...variant,
        thumbnail_url: variant.thumbnail_url || row.thumbnail_url || defaultImage,
      }))
    : [],
})
